"use client";
import { useEffect, useMemo } from "react";

import ChevronDown from "@/components/icons/ChevronDown";
import Button from "@/components/ui/Button";
import {
  PopoverContent,
  PopoverRoot,
  PopoverTrigger,
} from "@/components/ui/Popover";
import { DepictSortOption } from "@/lib/depict/types";
import { useUrlSearchParams } from "@frend-digital/ui/next";
import clsx from "clsx";
import SortButton from "../../PlpButtons/SortButton";
import { searchParamOptions } from "../Filter/FilterModal";
import styles from "./sort-modal.module.css";

const SortModal = ({ sorts }: { sorts: DepictSortOption[] | undefined }) => {
  const searchParams = useUrlSearchParams(searchParamOptions);
  const selectedValue = searchParams.get("sort");

  useEffect(() => {
    const urlSort = searchParams.get("sort");
    if (!urlSort) return;
    /*    if (option.key === urlSort) {
        option.setFunction();
      } */
  }, [searchParams]);

  const selectedSortTitle = useMemo(() => {
    return sorts?.find(sort => {
      const [sortValue, order] = selectedValue?.split(":") ?? [];
      return sort.field === sortValue && sort.order === order;
    })?.meta?.title;
  }, [selectedValue, sorts]);

  return (
    <PopoverRoot key={"sort"} /* className={styles.modal} */>
      <PopoverTrigger asChild className={styles.sort}>
        <div className={styles.sortBy}>
          <SortButton>
            <span>
              <span>Sort by</span>
              {selectedSortTitle && (
                <>
                  <span>/</span>
                  <span>{selectedSortTitle}</span>
                </>
              )}
              <ChevronDown />
            </span>
          </SortButton>
        </div>
      </PopoverTrigger>
      <PopoverContent className={styles.sortPopover}>
        <div className={styles["sort-options"]}>
          {sorts?.map((option, i) => {
            const optionActive =
              searchParams.get("sort") === `${option.field}:${option.order}`;
            return (
              <div
                className={clsx(
                  styles["sort-option"],
                  optionActive && styles.active,
                )}
                key={i}
              >
                <Button
                  mode="unset"
                  onClick={() => {
                    searchParams.delete("sort");
                    searchParams.set("sort", `${option.field}:${option.order}`);
                  }}
                >
                  {option.meta?.title}
                </Button>
              </div>
            );
          })}
        </div>
      </PopoverContent>
    </PopoverRoot>
  );
};

export default SortModal;
